import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { serviceurl } from '../constant/constant';

@Injectable({
  providedIn: 'root'
})
export class CommonUploadImageService {



  constructor(
    private http: HttpClient
  ) { }


  userImageUpload(data) {
    return this.http.put(serviceurl + "user/userimageupload/", data)
  }

  playerImageUpload(data) {
    
    const formData = new FormData()
    formData.append('character_id', data.character_id)
    formData.append('regular_image', data.regular_image)
    formData.append('cropped_image', data.cropped_image)
    return this.http.put(serviceurl + 'character/charcterimageupload/', formData);
  }

  gameMasterPartyTokenUpload(data: any) {
    return this.http.put(serviceurl + 'gamemaster/gamemasterimageupload/', data);
  }

  gamedetailimgupload(data:any){
    return this.http.put(serviceurl + 'gameuser/UpdatedGameDetailsImageByGameId/',data);
  }

  getTokens(user_id:number) {
   return this.http.get(serviceurl + `user/${user_id}/party-tokens/`)
  }

  uploadToken(user_id:number,croppedImageData:any) {
    return this.http.post(serviceurl + `user/${user_id}/party-tokens/upload/`, croppedImageData)
  }
}
